<template>
  <dl
    class="icon-details-categories display-inline-flex flex-items-center flex-content-center flex-wrap"
    style="--margin-bottom: 0; --padding-left: 0; gap: var(--spacing-md)"
  >
    <dt
      class="muted sr-only"
      style="--margin-bottom: 0; font-weight: var(--font-weight-normal)"
    >
      Found in the following categories:
    </dt>
    <dd
      v-for="category in sampleCategories"
      :key="category"
      style="--margin-bottom: 0"
    >
      <site-link
        :to="$category({ name: category })"
        class="tag rounded blue"
        style="--link-decoration-line: none"
        @click.native="clickCategory(category)"
        >{{ category }}</site-link
      >
    </dd>
  </dl>
</template>

<script>
  import { sampleSize, sortBy } from 'lodash'
  import { EventTrackingMixin } from 'app/mixins'

  export default {
    name: 'IconCategories',

    mixins: [EventTrackingMixin],

    props: {
      categories: {
        type: Array,
        required: true
      },
      isUsingModal: {
        type: Boolean,
        required: true
      },
      icon: {
        type: Object,
        required: true
      }
    },

    computed: {
      sampleCategories() {
        return sortBy(sampleSize(this.categories, 5))
      }
    },

    methods: {
      clickCategory(category) {
        this.$posthog.capture('icon_category_link_click', {
          category: category,
          context: `${this.iconModalContext(this.isUsingModal)}`,
          icon_name: this.icon.name,
          icon_style: this.icon.style,
          icon_family: this.icon.family
        })

        this.$emit('closeModal')
      }
    }
  }
</script>
